/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMemberRequest,
  getCoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMemberRequestErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMemberRequest';
import {
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse,
  getCoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse';

type UpdateOrganizationMemberRoleMutationArgs =
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMemberRequest;

export type UpdateOrganizationMemberRoleResult =
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse;

const validateUpdateOrganizationMemberRoleResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: UpdateOrganizationMemberRoleResult data does not match contract.`,
      errors,
    );
  }
};

type HookReturnType = (
  payload: Readonly<UpdateOrganizationMemberRoleMutationArgs>,
  options?: RequestInit,
) => Promise<UpdateOrganizationMemberRoleResult | ErrorTypes>;

export const getUpdateOrganizationMemberRoleUrl = () => {
  const searchParams = new URLSearchParams();
  const url = `${getBaseUrl()}/organization/v1/member/role${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Put UpdateOrganizationMemberRole
 * @Url /organization/v1/member/role
 * @Auth Required
 */
export const useUpdateOrganizationMemberRole = (): HookReturnType => {
  const mutation = useMutation<unknown, UpdateOrganizationMemberRoleResult>();

  const callback = useCallback(
    async (payload: Readonly<UpdateOrganizationMemberRoleMutationArgs>, options?: RequestInit) => {
      const postBody = {
        organization_id: payload.organizationId,
        legal_entity_id: payload.legalEntityId,
        member_uuid: payload.memberUuid,
        role: payload.role,
        roles: payload.roles,
        legal_entity_roles: payload.legalEntityRoles,
        removed_legal_entity_ids: payload.removedLegalEntityIds,
      };

      const init = { ...(options || {}), method: 'PUT' };

      const url = getUpdateOrganizationMemberRoleUrl();
      const result = await mutation(url, postBody, init);
      if (process.env.NODE_ENV !== 'production') {
        validateUpdateOrganizationMemberRoleResult(result);
      }
      return result;
    },
    [mutation],
  );

  return callback;
};
